import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faTimes, faExternalLinkAlt, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../App';
import '../styles/AnnouncementBanner.css';

const AnnouncementBanner = ({ style, auth }) => {
  const [bannerData, setBannerData] = useState(null);
  const [allLevels, setAllLevels] = useState([]);
  const [selectedLevelId, setSelectedLevelId] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/banner`);
        if (response.data.success && Array.isArray(response.data.data)) {
          setAllLevels(response.data.data);
          let userLevelId = auth && auth.level ? Number(auth.level) : null;
          if (userLevelId) {
            setSelectedLevelId(userLevelId);
            const level = response.data.data.find(l => Number(l.level_id) === userLevelId);
            if (level && Array.isArray(level.banners) && level.banners.length > 0) {
              setBannerData({ ...level.banners[0], level_name: level.level_name });
            } else {
              setBannerData(null);
            }
          } else {
            // Not logged in: default to first level
            if (response.data.data.length > 0) {
              setSelectedLevelId(Number(response.data.data[0].level_id));
              const level = response.data.data[0];
              if (level.banners && level.banners.length > 0) {
                setBannerData({ ...level.banners[0], level_name: level.level_name });
              } else {
                setBannerData(null);
              }
            }
          }
        }
      } catch (error) {
        console.error('Error fetching banner:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchBanner();
  }, [auth]);

  // Handle toggle for guest (not logged in)
  const handleLevelToggle = (levelId) => {
    setSelectedLevelId(levelId);
    const level = allLevels.find(l => Number(l.level_id) === levelId);
    if (level && Array.isArray(level.banners) && level.banners.length > 0) {
      setBannerData({ ...level.banners[0], level_name: level.level_name });
    } else {
      setBannerData(null);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleClick = () => {
    if (bannerData?.link_url) {
      window.open(bannerData.link_url, '_blank');
    }
  };

  if (isLoading || !bannerData || !isVisible) {
    return null;
  }

  // Show toggles if not logged in or no level
  const showToggles = !(auth && auth.level);

  return (
    <div className={`announcement-banner ${style ? 'dark-mode' : ''}`}>
      <div className="banner-content">
        <div className="banner-icon">
          <FontAwesomeIcon icon={faBell} />
        </div>
        <div className="banner-text">
          <h3>{bannerData.title}</h3>
          <p>{bannerData.description}</p>
          {bannerData.level_name && (
            <div style={{ fontSize: '1rem', opacity: 0.7, marginTop: 4 }}>{bannerData.level_name}</div>
          )}
        </div>
        <div className="banner-actions">
          {bannerData.link_url && (
            <button 
              className="banner-link-btn"
              onClick={handleClick}
            >
              <FontAwesomeIcon icon={faExternalLinkAlt} />
              <span>شوف التفاصيل</span>
            </button>
          )}
          <button 
            className="banner-close-btn"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
        {showToggles && allLevels.length > 1 && (
          <div style={{ display: 'flex', gap: 8, marginLeft: 16 }}>
            {allLevels.map(level => (
              <button
                key={level.level_id}
                onClick={() => handleLevelToggle(Number(level.level_id))}
                style={{
                  background: Number(level.level_id) === selectedLevelId ? '#fff' : 'rgba(255,255,255,0.15)',
                  color: Number(level.level_id) === selectedLevelId ? '#00b4b4' : '#fff',
                  border: '1px solid rgba(255,255,255,0.25)',
                  borderRadius: 16,
                  padding: '6px 14px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  fontSize: '1rem',
                  transition: 'all 0.2s',
                  marginRight: 4
                }}
              >
                {level.level_name}
              </button>
            ))}
          </div>
        )}
      </div>
      <div className="banner-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </div>
  );
};

export default AnnouncementBanner; 